import { useEffect, useState, type ReactNode } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { initAdMob, isAdMobAvailable } from "@/lib/admob";
import BrandLogo from "@/components/BrandLogo";

const STARTUP_SPLASH_MIN_MS = 1200;

function AdMobBootstrap() {
  useEffect(() => {
    if (!isAdMobAvailable()) return;
    void initAdMob();
  }, []);
  return null;
}

function StartupSplashGate({ children }: { children: ReactNode }) {
  const { authReady } = useAuth();
  const [minElapsed, setMinElapsed] = useState(false);

  useEffect(() => {
    const t = window.setTimeout(() => setMinElapsed(true), STARTUP_SPLASH_MIN_MS);
    return () => window.clearTimeout(t);
  }, []);

  if (!authReady || !minElapsed) {
    return (
      <div
        className="min-h-screen flex items-center justify-center px-6"
        style={{
          background: "linear-gradient(160deg, #0d1f1f 0%, #1a2f2f 40%, #0f1a1a 100%)",
        }}
      >
        <BrandLogo />
      </div>
    );
  }

  return <>{children}</>;
}

export default function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AuthProvider>
          <AdMobBootstrap />
          <StartupSplashGate>
            <AppRoutes />
          </StartupSplashGate>
        </AuthProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}
